import React from "react"
import IconButton from '@material-ui/core/IconButton'
import Badge from '@material-ui/core/Badge'

import { useCircle } from "./circle.selectors"
import { Link as RouterLink } from "react-router-dom"
import { circleMembersUrl } from "./places"
import { UsersIcon } from "core/icons"


export const MembersIcon = () => {
    const circle = useCircle()
    const to = circleMembersUrl(circle?._id)
    return (
        <IconButton aria-label="show members" color="inherit" component={RouterLink} to={to} data-intro="members">
            <Badge badgeContent={circle?.stats?.memberCount} color="secondary">
                <UsersIcon />
            </Badge>
        </IconButton>
    )
}
